module.exports = __webpack_public_path__ + "static/img/22.631c53f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/22.jpg
// module id = JXln
// module chunks = 0